module.exports = __webpack_public_path__ + "static/media/app-store.3ec6ac11.png";